module.exports = __webpack_public_path__ + "img/userstories.e8adb027.jpg";